
import { ContactUs, Home, MedevacServices, OccupationalHealthServices, RemoteSiteMedicalSolutions, PublicHealthcareServices, TelemedicineServices } from './pages';

export const routes = [
    { title: 'Home', path: '/', element: Home },
    { title: 'Remote Site Medical Services', path: '/remote-site-medical-solutions', element: RemoteSiteMedicalSolutions },
    { title: 'Telemedicine Services', path: '/telemedicine-services', element: TelemedicineServices },
    { title: 'MEDEVAC Services', path: 'medevac-services', element: MedevacServices },
    { title: 'Public Healthcare Services', path: '/public-healthcare-services', element: PublicHealthcareServices },
    { title: 'Occupational Health Services', path: '/occupational-health-services', element: OccupationalHealthServices },
    { title: 'Contact Us', path: '/contact-us', element: ContactUs },
]
